import {getAllDeletedProjectsURL, getAllProjectsURL, restoreDeletedProject} from "../../../services/api";
import {
    LOADING_PROJECTS,
    FETCH_PROJECTS,
    FETCH_PROJECTS_FAIL,
    FETCH_DELETED_PROJECTS,
    FETCH_DELETED_PROJECTS_FAIL,
    LOADING_DELETED_PROJECTS, LOADING_RESTORE_PROJECT, RESTORE_PROJECT,
} from "./actionTypes";
import api from '../../../services/instanceapi'
import {checkErrorMessage} from "../../../utils/utils";

export const loadProjects = (currentUserId) => async (dispatch) => {
    dispatch({
        type: LOADING_PROJECTS,
    });

    try {
        const {data} = await api.get(getAllProjectsURL(currentUserId));
        dispatch({
            type: FETCH_PROJECTS,
            payload: {
                projects: data,
                status: 200,
                message: "OK"
            }
        });
        return Promise.resolve();

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status

        if (status !== 200) {
            dispatch({
                type: FETCH_PROJECTS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            });
        }
        return Promise.reject(e);
    }
}
export const loadDeletedProjects = () => async (dispatch) => {
    dispatch({
        type: LOADING_DELETED_PROJECTS,
    });

    try {
        const {data} = await api.get(getAllDeletedProjectsURL());
        dispatch({
            type: FETCH_DELETED_PROJECTS,
            payload: {
                deletedProjects: data,
                status: 200,
                message: "OK"
            }
        });
        return Promise.resolve();

    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status

        if (status !== 200) {
            dispatch({
                type: FETCH_DELETED_PROJECTS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            });
        }
        return Promise.reject(e);
    }
}


export const restoreProject = (id) => async (dispatch) => {
    dispatch({
        type: LOADING_RESTORE_PROJECT,
    });
    try {
        const data = await api.post(restoreDeletedProject(id));
        dispatch({
            type: RESTORE_PROJECT,
            status: data.status,
            message: 'restored'
        });
        return Promise.resolve();


    } catch (e) {
        /*    const message = checkErrorMessage(e)
          const status = e.response.status
          if (status !== 200) {
              dispatch({
                  type: RESTORE_PROJECT_FAIL,
                payload: {
                      status: status,
                      message: message
                  }
            })
        };*/
        return Promise.reject(e);
    }
}